import type { Patient } from "$global-providers/rxdb-provider/collections/patient";

/**
 * Since we soft delete guardians from an RxPatient, we need find one from the
 * list of guardians that has meta.deleted === false
 */
export const getActiveGuardian = (patient: Patient) => {
  if (!patient.guardians || patient.guardians.length === 0) {
    return null;
  }

  // Find the first guardian that has meta.deleted === false
  return patient.guardians.find(
    (guardian) => guardian.meta && !guardian.meta.deleted,
  );
};
